import React from "react";
import { useNavigate } from "react-router-dom";
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
  useIsAuthenticated,
  useMsal,
} from "@azure/msal-react";
import { InteractionStatus } from "@azure/msal-browser";
import { loginRequest } from "../../authConfig";

function AuthComponent() {
  const { instance, inProgress, accounts } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const navigate = useNavigate();
  const loginInvoked = React.useRef(false);
  const redirectHandled = React.useRef(false);
  const [errorMessage, setErrorMessage] = React.useState("");

  // Trigger login
  React.useEffect(() => {
    if (
      !isAuthenticated &&
      inProgress === InteractionStatus.None &&
      !loginInvoked.current
    ) {
      loginInvoked.current = true;

      instance
        .loginRedirect({
          ...loginRequest,
          prompt: "create",
        })
        .catch((error) => {
          console.error("MSAL loginRedirect error", error);
          setErrorMessage(error?.message || "Login failed");
          loginInvoked.current = false;
        });
    }
  }, [instance, isAuthenticated, inProgress]);

  // After redirect login success → go to app immediately
  React.useEffect(() => {
    if (
      isAuthenticated &&
      inProgress === InteractionStatus.None &&
      !redirectHandled.current
    ) {
      redirectHandled.current = true;

      navigate("/create", { replace: true });
    }
  }, [isAuthenticated, inProgress, navigate]);

  if (inProgress !== InteractionStatus.None) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        Loading...
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center min-h-screen">
      {!isAuthenticated && (
        <>
          <p>Redirecting to Microsoft...</p>
          {errorMessage && (
            <div className="mt-4 text-red-600 text-sm">{errorMessage}</div>
          )}
        </>
      )}
    </div>
  );
}


export default AuthComponent;
